"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0; // ARCHITECT-MIXINS [ ADD > ANGLE ] ############################################
// 1. DEPENDENCIES +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 1.1. EXTERNAL DEPENDENCIES ..................................................
// 1.1. END ....................................................................
// 1.2. INTERNAL DEPENDENCIES ..................................................
// 1.2. END ....................................................................
// 1. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 2. COMPONENT ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

var _default = function _default(direction) {
  var position = function position(DIRECTION) {
    switch (DIRECTION) {
      case 'left':
        return "\n          z-index: 9;\n          margin-top: var(--gutter-medium);\n          margin-bottom: calc(var(--gutter-medium) - 1px);\n          &:before {\n            clip-path: var(--angle-left-top);\n          }\n          &:after {\n            clip-path: var(--angle-left-bottom);\n          }\n        ";

      case 'center':
        return "\n          z-index: 9;\n          margin-top: var(--gutter-medium);\n          margin-bottom: calc(var(--gutter-medium) - 1px);\n          &:before {\n            clip-path: var(--angle-center-top);\n          }\n          &:after {\n            clip-path: var(--angle-center-bottom);\n          }\n        ";

      case 'right':
        return "\n          z-index: 9;\n          margin-top: var(--gutter-medium);\n          margin-bottom: calc(var(--gutter-medium) - 1px);\n          &:before {\n            clip-path: var(--angle-right-top);\n          }\n          &:after {\n            clip-path: var(--angle-right-bottom);\n          }\n        ";

      default:
        return null;
    }
  };

  if (direction && direction !== 'none') {
    return "\n    position: relative;\n    z-index: 2;\n\n    &:before {\n      content: \"\";\n      height: var(--gutter-medium);\n      background: blue;\n      position: absolute;\n      left: 0;\n      right: 0;\n      bottom: 100%;\n    }\n    &:after {\n      content: \"\";\n      height: var(--gutter-medium);\n      background: blue;\n      position: absolute;\n      left: 0;\n      right: 0;\n      top: 100%;\n    }\n\n    ".concat(position(direction), "\n\n  ");
  }

  return null;
}; // 2. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// END OF FILE #################################################################


exports["default"] = _default;